export default __webpack_public_path__ + "static/media/2078_00 drawing.bce00904.gif";